// extracted by mini-css-extract-plugin
module.exports = {"color-currentColor":"styles_color-currentColor__1q5WD","spinner":"styles_spinner__1HK2U","rotation":"styles_rotation__2pdkm"};